import ReactPaginate from 'react-paginate'
import styles from './pagination.module.scss'
import clsx from 'clsx'
import {Col} from 'react-bootstrap'
interface PaginationProps {
  limit: number
  onPageChange: (selectedPage: number) => void
  onLimitChange: (limit: number) => void
  isLoading?: boolean
  total: number
  totalPages: number
  loadedData: {
    startLoad: number
    endLoad: number
  }
}

const LIMIT_OPTIONS = [10, 20, 50]
const Pagination = ({
  limit,
  onPageChange,
  onLimitChange,
  isLoading,
  loadedData,
  total,
  totalPages,
}: PaginationProps) => {
  return (
    <div className={clsx(styles['pagination-container'])}>
      <Col xs={12} md={6} className={styles['pagination-info']}>
        <select
          onChange={(e) => {
            onLimitChange(parseInt(e.target.value))
          }}
          value={limit}
        >
          {LIMIT_OPTIONS.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        {isLoading
          ? '. . . . .'
          : `Show ${loadedData.startLoad} - ${loadedData.endLoad} of ${total} data`}
      </Col>
      <Col xs={12} md={6}>
        <ReactPaginate
          previousLabel='<'
          nextLabel='>'
          pageCount={totalPages}
          onPageChange={({selected}) => {
            onPageChange(selected)
          }}
          containerClassName={clsx(styles['pagination-custom'])}
          previousLinkClassName={styles['pagination__link']}
          nextLinkClassName={styles['pagination__link']}
          disabledClassName={styles['pagination__link--disabled']}
          activeClassName={styles['pagination__link--active']}
        />
      </Col>
    </div>
  )
}

export default Pagination
